import type { HTMLAttributes } from 'react'

type Tone = 'neutral' | 'brand' | 'info' | 'accent' | 'warning' | 'danger' | 'success'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone
}

const TONE_CLS: Record<Tone, string> = {
  neutral:
    'bg-[var(--xr-bg-surface-elev)] text-[var(--xr-text-secondary)] border-[var(--xr-border-default)]',
  brand:
    'bg-[var(--xr-brand-primary-soft)] text-[var(--xr-brand-primary)] border-[var(--xr-brand-primary)]/20',
  // Info tone — functional cool slate (informational). Uses --xr-info; replaces
  // the retired Lake "water" tone (water sports dropped, ADR 06).
  info: 'bg-[var(--xr-info-soft)] text-[var(--xr-info)] border-[var(--xr-info)]/25',
  accent: 'bg-[var(--xr-accent-soft)] text-[var(--xr-accent)] border-[var(--xr-accent)]/30',
  // Warning — gold/amber feedback, distinct from accent (orange = live/track).
  warning: 'bg-[var(--xr-warning-soft)] text-[var(--xr-warning)] border-[var(--xr-warning)]/30',
  danger: 'bg-[var(--xr-danger-soft)] text-[var(--xr-danger)] border-[var(--xr-danger)]/30',
  success: 'bg-[var(--xr-success-soft)] text-[var(--xr-success)] border-[var(--xr-success)]/30',
}

export function Badge({ tone = 'neutral', className = '', ...rest }: BadgeProps) {
  const cls =
    `inline-flex items-center px-2 py-0.5 rounded-[var(--xr-radius-sm)] border text-[11px] font-medium uppercase tracking-wider ${TONE_CLS[tone]} ${className}`.trim()
  return <span className={cls} {...rest} />
}
